module.exports = __webpack_public_path__ + "img/chevron-up.5caf18d8.svg";